angular.module('dnecom')
    .controller('MockupProcessController', ["$scope", "$http", "$uibModal", "notifications", "MediaUtils", "MediaSrc", "SizeProfileUtils", "$rootScope", function MockupProcessController($scope, $http, $uibModal, notifications, MediaUtils, MediaSrc, SizeProfileUtils, $rootScope) {
        $scope.mockup = TemplateData.value('mockup');
        $scope.accounts = TemplateData.value('accounts');
        $scope.designs = TemplateData.value('designs');

        $scope.sz = {};
        $scope.sz.sizeProfiles = TemplateData.value('sizeProfiles');
        $scope.sz.sizeProfileSelectorVisible = false;
        $scope.sz.sizeProfileInput = '';

        $scope.selectColorForPreview = function(color) {
            if (areColorsEqual(color, $scope.mockup.properties.previewColor)) {
                $scope.mockup.properties.previewColor = null;
                return;
            }

            $scope.mockup.properties.previewColor = color;

            var active = true;
            var imageUrl = $scope.mockup.properties.images[$scope.mockup.properties.previewColor.name][$scope.mockup.currentTemplate];

            // Set first image as active
            angular.forEach($scope.mockup.properties.previewColor.images, function(image) {
                image.active = active;

                if (active) {
                    $scope.mockup.properties.previewImageUrl = imageUrl ? imageUrl : image.url;
                    active = false;
                }
            });
        };

        $scope.isColorSelectedForPreview = function(color) {
            return areColorsEqual($scope.mockup.properties.previewColor, color);
        };

        $scope.getPreviewImageUrl = function() {
            return $scope.mockup.properties.previewImageUrl;
        };

        $scope.setPreviewImage = function(side, image) {
            angular.forEach($scope.mockup.properties.previewColor.images, function(item) {
                item.active = false;
            });

            $scope.mockup.properties.previewImageUrl = $scope.getGeneratedImageUrl(side, image);
            image.active = true;
        };

        $scope.getPreviewImagesList = function() {
            var out = {};

            if (!$scope.mockup || !$scope.mockup.properties || !$scope.mockup.properties.previewColor) {
                return out;
            }

            angular.forEach($scope.mockup.properties.previewColor.images, function(image, side) {
                var url = $scope.getGeneratedImageUrl(side, image);

                if (url) {
                    out[side] = image;
                }
            });

            return out;
        };

        $scope.getGeneratedImageUrl = function(side, image) {
            var colorName = $scope.mockup.properties.previewColor.name;

            if (!$scope.mockup.properties.images || !$scope.mockup.properties.images[colorName]) {
                return '';
            }

            return $scope.mockup.properties.images[colorName][side];
        };

        $scope.deleteColor = function($event, color) {
            $event.preventDefault();

            angular.forEach($scope.mockup.properties.selectedColors, function(item, index) {
                if (areColorsEqual(item, color)) {
                    $scope.mockup.properties.selectedColors.splice(index, 1);
                    $scope.mockup.properties.selectedColor = null;
                    $scope.mockup.properties.previewColor = null;
                }
            });
        };

        $scope.getProviderName = function() {
            var name = '';

            angular.forEach($scope.accounts, function(account) {
                if (account.id == $scope.mockup.provider) {
                    name = account.name;
                }
            });

            return name;
        };

        $scope.save = function(form) {
            form.$setTouched();

            if (form.$invalid) {
                return;
            }

            $http.post(
                Routing.generate('mockup_update', {
                    id: $scope.mockup.id || 0
                }),
                $scope.mockup
            ).then(function(response) {
                if (!response.data.success) {
                    notifications.danger(response.data.message || 'Failed to save mockup.');
                    return;
                }

                notifications.success('Mockup saved successfully.');
                $scope.mockup = response.data.mockup;
                MediaUtils.processDelete();
            }, function(response) {
                if (!response.hasOwnProperty('data') || !response.data.hasOwnProperty('errors')) {
                    notifications.danger('Invalid server response.');
                    return;
                }

                $scope.serverErrors = ErrorBag.from(response.data.errors);
                notifications.danger('Form contains invalid data.');
            });
        };

        $scope.delete = function() {
            $http.delete(
                Routing.generate('mockup_delete', {
                    id: $scope.mockup.id
                })
            ).then(function(response) {
                if (!response.data.success) {
                    notifications.danger(response.data.message || 'Failed to delete mockup.');
                    return;
                }

                notifications.success('Mockup deleted successfully.');
                window.location = Routing.generate('mockups');
            }, function() {
                notifications.danger('Invalid server response.');
            });
        };

        $scope.searchSizeProfiles = function (event) {
            if (event) {
                event.preventDefault();
            }

            $scope.sz.sizeProfileSelectorVisible ? $scope.sz.sizeProfileSelectorVisible = false : $scope.sz.sizeProfileSelectorVisible = true;
        };

        $scope.getImplodedSizes = function (sizeProfile) {
            var t = SizeProfileUtils.getProfileSizes(sizeProfile);
            return t.join(', ');
        };

        $scope.selectSizeProfile = function (sizeProfile) {
            $scope.mockup.sizeProfile = sizeProfile;
            $scope.sz.sizeProfileSelectorVisible = false;
            $scope.sz.sizeProfileInput = '';
        };

        $scope.removeSizeProfile = function (event) {
            event.preventDefault();
            $scope.mockup.sizeProfile = null;
        };

        $scope.openDesignGalleryModal = function ($event) {
            $event.preventDefault();

            $uibModal.open({
                templateUrl: 'designGalleryModal.html',
                controller: 'MockupDesignGalleryModalController',
                animation: true,
                windowClass: 'modal-primary',
                backdrop: 'static',
                size: 'xlg',
                resolve: {
                    designs: function () {
                        return $scope.designs;
                    },
                    mockup: function () {
                        return $scope.mockup;
                    },
                    locations: function () {
                        return $scope.mockup.product.templates;
                    }
                }
            }).result.then(function(result) {
                $scope.mockup.designs = result;
            });
        };

        $rootScope.$on('designs.update', function($event, designs) {
            $scope.designs = angular.copy(designs);
        });

        var areColorsEqual = function(color1, color2) {
            if (!color1 || !color2) {
                return false;
            }

            return color1.hex == color2.hex && color1.name == color2.name;
        };
    }]);
